import React, { FC, ReactNode } from 'react'
import { Helmet } from 'react-helmet'
import { use100vh } from 'react-div-100vh'
import styles from 'styles/components/layout.module.scss'

type Props = {
  title: string
  children: ReactNode
}

const FixedLayout: FC<Props> = ({ children, title }) => {
  const height = use100vh()
  return (
    <>
      <Helmet>
        <title>{title} | sacri for Owners</title>
      </Helmet>
      <main className={styles.main} style={{ minHeight: height ?? '100vh' }}>
        <section className={styles.section}>{children}</section>
      </main>
    </>
  )
}

export default FixedLayout
